import * as Yup from 'yup';

const LoginSchema = Yup.object({
  username: Yup.string()
    .trim()
    .min(3, 'must be at least 3 characters long')
    .required('The username field is required.'),
  password: Yup.string()
    .trim()
    .required('The password field is required.'),
})
const ForgotPasswordSchema = Yup.object({
  username: Yup.string()
    .trim()
    .min(3, 'must be at least 3 characters long')
    .required('The username field is required.')
})

export default LoginSchema;